export const SUCCESS = 'Success';
export const FAILURE = 'Failure';

export const REASON_SCREENOUT = 'ClientRulesScreenout';
export const REASON_PROFILING = 'ClientRulesProfiling';
export const REASON_QUALITY = 'ClientRulesQuality';
export const REASON_SCREENING_QUOTA_FULL = 'ScreeningQuotaFull';
export const REASON_QUESTIONNAIRE_QUOTA_FULL = 'QuestionnaireQuotaFull';
